<template>
  <div style="padding-bottom:44px">
    <van-field label="序列号" v-model="hwsy01_Step2.serialNumber">
      <template #right-icon>
        <van-tag type="warning">{{jieMa}}</van-tag>
      </template>
    </van-field>
    <van-cell title="设备解码">
      <template #right-icon>
        <van-checkbox v-model="hwsy01_Step2.sheBeiJieMa" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="温度标定">
      <template #right-icon>
        <van-checkbox v-model="hwsy01_Step2.wenDuBiaoDing" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="温度用检定设备检测--随机抽取检测 每一批必须检测">
      <template #right-icon>
        <van-checkbox v-model="hwsy01_Step2.wenDuJianCe" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="加热 制冷 循环能否正常工作">
      <template #right-icon>
        <van-checkbox v-model="hwsy01_Step2.jiaReZhiLengXunHuan" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="温度控制正常">
      <template #right-icon>
        <van-checkbox v-model="hwsy01_Step2.wenDuKongZhi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-field label="备注" v-model="hwsy01_Step2.remark"> </van-field>
    <el-button type="primary" class="footer1" icon="el-icon-view" circle @click="handlePicClick"></el-button>
    <div class="footer">
      <van-button type="info" v-show="$parent.hasPower_Step2" round block :disabled="$parent.hwsy01_SignNumber.status!=0" @click="handleSave">保存</van-button>
      <van-button type="danger" v-if="$parent.hwsy01_SignNumber.status==2" round block @click="$parent.cancel_void_SignNumber()">取消作废</van-button>
      <van-button type="danger" v-else-if="$parent.hwsy01_SignNumber.status!=1" round block @click="$parent.void_SignNumber()">作废</van-button>

    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  props: ["signNumber"],
  data() {
    return {
      hwsy01_Step2: {},
      jieMa: "",
    };
  },
  methods: {
    handlePicClick() {
      ImagePreview(["./images/HWSY01_Produce1.png"]);
    },
    getHWSY01_Step2() {
      let that = this;
      that.axios
        .post("/HWSY01/GetHWSY01_Step2", { onlyText: that.signNumber })
        .then(function (response) {
          that.hwsy01_Step2 = response.data.data;
        });
    },
    handleSave() {
      let that = this;
      that.axios
        .all([that.save_HWSY01_Step2(), that.registerSerialNumber()])
        .then(
          that.axios.spread(function (response1, response2) {
            that.hwsy01_Step2 = response1.data.data;
            if (response1.data.code == 201) {
              that.$notify({ type: "warning", message: response1.data.msg });
            } else if (response2.data.code == 201) {
              that.$notify({ type: "warning", message: response2.data.msg });
            } else {
              that.$notify({ type: "success", message: response1.data.msg });
            }
            if (response2.data.code == 101) {
              that.jieMa = response2.data.msg;
            }
          })
        );
    },
    save_HWSY01_Step2() {
      let that = this;
      return that.axios.post("HWSY01/UpdateHWSY01_Step2", that.hwsy01_Step2);
    },
    registerSerialNumber() {
      let that = this;
      return that.axios.post("Base_Device/Register", {
        productName: "温控表",
        productId: 1088,
        serialNumber: that.hwsy01_Step2.serialNumber,
        deviceType: "HWSY01",
        companyName: "",
        ifPrint: false,
      });
    },
  },
  mounted() {
    let that = this;
    that.getHWSY01_Step2();
  },
};
</script>

<style scoped>
.footer {
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
}
.footer1 {
  position: fixed;
  left: 10px;
  bottom: 50px;
}
</style>